import noop from "lodash/noop";
export function muteResizeObserverError() {
  var muteErrorCallback = function (e) {
    if ("ResizeObserver loop limit exceeded" === e.message) {
      var webpackOverlay = document.getElementById("webpack-dev-server-client-overlay");
      webpackOverlay && webpackOverlay.setAttribute("style", "display: none");
    }
  };
  return "development" !== process.env.NODE_ENV ? noop : (window.addEventListener("error", muteErrorCallback), function () {
    return window.removeEventListener("error", muteErrorCallback);
  });
}